import React from "react";
import Input from "../../../stories/Input/Input";
interface Props {
  state_code: string;
  values: string;
  name: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required: boolean | undefined;
  max: number;
}
const GstInputComponent = ({
  state_code,
  values,
  name,
  onChange,
  required,
  max,
}: Props) => {
  return (
    <div className="gst-input">
      <div className="gst-input__state">{state_code}</div>
      <Input
        className="gst-input__input"
        value={values}
        name={name}
        onChange={onChange}
        required={required}
        maxLength={max}
      />
    </div>
  );
};

export default GstInputComponent;
